<template>
  <section>
    <div class="flex items-center justify-between mb-4">
      <h4 class="mb-2">
        {{ $t("stats.course.sidebar.quiz") }}
      </h4>
      <Button
        :label="$t('labels.generic', { pt: 'Baixar', en: 'Download' })"
        icon="pi pi-download"
        class="p-button-sm btn-primary h-9"
        :loading="btnLoading"
        @click="downloadCSV"
      />
    </div>
    <div class="bg-white rounded-lg border border-gray-300">
      <Table
        :slotData="quiz"
        :columns="columns"
        :hasActions="false"
        :loading="loading"
        :filters="filters"
        :params="params"
        :hasStatus="true"
        @onFilter="filterFor()"
        @onPaginate="paginate($event)"
        @onClearFilter="clearFilter()"
        @onToggleFilter="(e, type) => toggleFilter(e, type)"
      >
        <template #filters>
          <InputText
            v-if="filterType == 'learningObjectiveName'"
            v-model="filters.name"
          />
        </template>
      </Table>
    </div>
  </section>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { ChaptersService } from "@/views/Chapters/chapters.service";
import { saveAs } from "file-saver";
import { delay } from "rxjs";
import { defineComponent } from "vue";
import { StatsService } from "../../stats.service";
import { QuizService } from "./quiz.service";
import { columns } from "./quiz.utils";

export default defineComponent({
  name: "quiz",
  computed: {
    rest(): StatsRest {
      return new StatsRest();
    },
    service(): QuizService {
      return new QuizService();
    },
    serviceChapters(): ChaptersService {
      return new ChaptersService();
    },
  },
  data() {
    return {
      courseId: this.$route.params.courseId as string,
      columns: columns as any,
      loading: true as boolean,
      btnLoading: false as boolean,
      quiz: [] as any,
      params: new QueryParams(),
      filters: {
        isCleareable: false,
        name: null,
      } as any,
      filterType: "" as string,
      classroomId: undefined as string | undefined,
    };
  },
  mounted() {
    this.quizesPaginated();
    this.getClassroomId();
  },
  watch: {
    classroomId(val, old) {
      if (val !== undefined || val !== old) this.quizesPaginated();
    },
  },
  methods: {
    paginate(event: { page: number; rows: number }): void {
      const params = new QueryParams(event.page, event.rows);
      params.name = this.filters.name;
      this.setPage(params);
    },
    setPage(queryParams: QueryParams): void {
      this.loading = true;
      queryParams.classroomId = this.classroomId ?? undefined;

      this.service.quiz.pipe(delay(500)).subscribe({
        next: (response: any) => {
          this.quiz = response.content;
          this.params.total = response.total;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
      this.service.getQuizFromCourse(this.courseId, queryParams);
    },
    quizesPaginated(): void {
      const page = this.params.page;
      const size = this.params.size;
      const params = new QueryParams(page, size);
      this.setPage(params);
    },
    toggleFilter(event: any, type: string): void {
      this.filterType = type;
    },
    filterFor(): void {
      this.filters.isCleareable = this.isCleareable();
      var params = new QueryParams();
      params.name = this.filters.name;
      if (this.filterType == "learningObjectiveName") {
        this.setPage(params);
      }
    },
    clearFilter(): void {
      this.filters.isCleareable = false;
      this.filters.name = null;
      this.quizesPaginated();
    },
    isCleareable(): boolean {
      return this.filters.name !== "";
    },
    downloadCSV(): void {
      this.btnLoading = true;
      this.rest
        .getQuizStatsCsv(this.courseId, {
          classroomId: this.classroomId ?? undefined,
        })
        .pipe(delay(1000))
        .subscribe({
          next: (response) => {
            this.btnLoading = false;
            const blob = new Blob([response], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            saveAs(url, `quiz_data.csv`);
          },
          error: () => {
            this.btnLoading = false;
          },
        });
    },
    getClassroomId(): void {
      this.loading = true;
      StatsService.classroom.subscribe({
        next: (e) => (this.classroomId = e),
      });
    },
  },
});
</script>
